var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgW2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 718,
    height: 897,
    fill: "none",
    viewBox: "0 0 718 897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.541
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)",
    opacity: 0.568
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 377.381,
    cy: 448.9,
    fill: "url(#paint0_linear)",
    rx: 203.4,
    ry: 132.617,
    transform: "rotate(90 377.381 448.9)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)",
    opacity: 0.424
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A6ECF",
    fillRule: "evenodd",
    d: "M264.796 365.817l21.754 57.355 80.831 59.184 43.301 7.944 24.304 19.966-7.693-72.225-41.811-35.941-40.242-19.8-80.444-16.483z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial)",
    fillRule: "evenodd",
    d: "M255.492 317.5c21.734 85.5 28.753 116.147 129.272 148.074 100.52 31.926 126.031 107.837 136.318 168.882 10.287 61.044-232.746 116.953-232.746 116.953L134.459 552.884l-41.88-294.113S233.757 232 255.491 317.5z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    width: 754.524,
    height: 896.091,
    x: 0.118,
    y: 0.855,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 122.323
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    width: 356.121,
    height: 330.38,
    x: 171.832,
    y: 272.851,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 46.483
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(154.145 136.633 268.212) scale(235.128 259.966)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 173.981,
    x2: 173.981,
    y1: 316.283,
    y2: 581.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72EBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA5E2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW2);
export default __webpack_public_path__ + "static/media/w2.23e3c4da68a437ea9f2d86cd2c72b170.svg";
export { ForwardRef as ReactComponent };